module.exports = __webpack_public_path__ + "img/java_light_grey.d8eaa4e9.jpg";